import { Channel } from '@at/consumer-web-types';
export * from '@at/consumer-web-types';
export const defaultChannel = Channel.cars;
export var CookiePolicy;
(function (CookiePolicy) {
    CookiePolicy["none"] = "none";
    CookiePolicy["seen"] = "seen";
})(CookiePolicy || (CookiePolicy = {}));
export class RedirectError extends Error {
    constructor(url, statusCode = 302) {
        const trueProto = new.target.prototype;
        super(`Redirecting to ${url} [${statusCode}]`);
        this.url = url;
        this.statusCode = statusCode;
        this.__proto__ = trueProto;
    }
}
export class NotFoundError extends Error {
    constructor(statusCode = 404, context = '') {
        const trueProto = new.target.prototype;
        super(`Not found [${context}] [${statusCode}]`);
        this.statusCode = statusCode;
        this.context = context;
        this.__proto__ = trueProto;
    }
}
